import { render } from "./MaintenanceBanner.vue?vue&type=template&id=1c037926&scoped=true&ts=true"
import script from "./MaintenanceBanner.vue?vue&type=script&lang=ts"
export * from "./MaintenanceBanner.vue?vue&type=script&lang=ts"

import "./MaintenanceBanner.vue?vue&type=style&index=0&id=1c037926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c037926"]])

export default __exports__